import React, { useEffect, useState } from "react";
import assets from "../../../../assets/assets";

function AllAnswerPopup({ setAllAnswerPopup, libraryQuestions, setOpenQuizPopup }) {
    const [showAnswer, setShowAnswer] = useState([])

    useEffect(() => {
        const AnswerList = libraryQuestions.map((item) => {
            return {
                title: item.title,
                answers: item.correct_answers.map((ans) => ({
                    key: ans.option_key,
                    value: ans.value,
                    explanation: ans.reason_for_answer.explanation
                }))
            };
        });
        setShowAnswer(AnswerList)
    }, [libraryQuestions]);
    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucessTakeQuizShowAllAnswer">
                <div>
                    {showAnswer.map((item, index) => (
                        <div key={index} className="mb-2">
                            <div className="font-semibold">{`Q${index + 1}.`} {item.title}</div>
                            {item.answers.map((ans, ansIndex) => (
                                <div className="ml-4 text-green-700" key={ansIndex}>
                                    <div className="font-semibold">Correct Answer: {ans.key}. {ans.value}</div>
                                    <div>Explanation {ans?.explanation}</div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="flex items-center justify-end mt-4">
                    <button
                        className={`nextBtnQue`}
                        onClick={(e) => {
                            setAllAnswerPopup(false)
                        }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>

    )
}

export default AllAnswerPopup;
